import { render, staticRenderFns } from "./AppPromotionBanner.vue?vue&type=template&id=37b42ade&scoped=true"
import script from "./AppPromotionBanner.vue?vue&type=script&lang=js"
export * from "./AppPromotionBanner.vue?vue&type=script&lang=js"
import style0 from "./AppPromotionBanner.vue?vue&type=style&index=0&id=37b42ade&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b42ade",
  null
  
)

export default component.exports